import { createSlice } from "@reduxjs/toolkit";

const settingSlice = createSlice({
    name: 'hiring',
    initialState: {
        hiring: [],
    },
    reducers: {
        hiringFlowLists: (state, action) => {
            state.hiring = action.payload.hiring;
        },
        
    }
});

export const { hiringFlowLists } = settingSlice.actions;
export default settingSlice.reducer;